var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampanitablanca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4904dc7f43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.15625 0 L 88.90625 0 L 88.90625 96 L 7.15625 96 Z M 7.15625 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4904dc7f43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M 48.03125 96 C 53.339844 96 57.640625 91.703125 57.640625 86.398438 L 38.421875 86.398438 C 38.421875 91.703125 42.722656 96 48.03125 96 Z M 79.257812 67.199219 L 79.257812 40.800781 C 79.257812 26.039062 69 13.726562 55.238281 10.464844 L 55.238281 7.199219 C 55.238281 3.214844 52.019531 0 48.03125 0 C 44.042969 0 40.824219 3.214844 40.824219 7.199219 L 40.824219 10.464844 C 27.0625 13.726562 16.804688 26.039062 16.804688 40.800781 L 16.804688 67.199219 L 7.195312 76.800781 L 7.195312 81.601562 L 88.867188 81.601562 L 88.867188 76.800781 Z M 79.257812 67.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanitablanca);
export default __webpack_public_path__ + "static/media/campanita.blanca.b685878446de88d09b005adb17f8f837.svg";
export { ForwardRef as ReactComponent };